export var TWENTY_FOUR_HOUR_TIME_REGEX = /^(0?[0-9]|1\d|2[0-3]):([0-5]\d)(:([0-5]\d))?$/;
export var TWELVE_HOUR_TIME_REGEX = /^(0?[1-9]|1[0-2]):([0-5]\d)(:([0-5]\d))?\s*([AaPp][Mm])?$/;
export var PARSEABLE_TIME_FORMAT = /^(\d\d?):?(\d\d?)(:?(\d?\d?))?\s*([AaPp][Mm]?)?$/;
export function tokenize24HourTimeString(value) {
    var matches = value.match(TWENTY_FOUR_HOUR_TIME_REGEX) || [null, 0, 0, null, 0];
    var hours = matches[1];
    var minutes = matches[2];
    var seconds = matches[4];
    return { hours: hours, minutes: minutes, seconds: seconds };
}
export function tokenize12HourTimeString(value) {
    var matches = value.match(TWELVE_HOUR_TIME_REGEX) || [null, 0, 0, null, 0, 'AM'];
    var hours = matches[1];
    var minutes = matches[2];
    var seconds = matches[4];
    var meridiem = matches[5];
    return { hours: hours, minutes: minutes, seconds: seconds, meridiem: meridiem };
}
export function isSupportedTimeFormat(value) {
    return TWENTY_FOUR_HOUR_TIME_REGEX.test(value) ||
        TWELVE_HOUR_TIME_REGEX.test(value);
}
export function tryCoerceTimeString(str, use24HourTime, allowSeconds) {
    str = str && typeof str === 'string' ? str.replace(/_|\s/g, '') : '';
    if (/^\s*$/.test(str)) {
        return '';
    }
    var matches = str.match(PARSEABLE_TIME_FORMAT);
    if (!matches) {
        return '';
    }
    var hoursStr = matches[1];
    var minutesStr = matches[2];
    var secondsStr = matches[4];
    var meridiem = matches[5];
    // Normalize the meridiem string
    if (use24HourTime) {
        meridiem = '';
    }
    else if (/[AaPp][Mm]/.test(meridiem)) {
        meridiem = meridiem.toUpperCase();
    }
    else {
        if (/^[AaPp]/.test(meridiem)) {
            if (meridiem.toLowerCase().startsWith('a')) {
                meridiem = 'AM';
            }
            else if (meridiem.toLowerCase().startsWith('p')) {
                meridiem = 'PM';
            }
        }
        else {
            meridiem = '';
        }
    }
    var hoursNum = +hoursStr || 0;
    var minutesNum = +minutesStr || 0;
    // Clamp and normalize hours
    var maxHours = !meridiem || use24HourTime ? 23 : 12;
    if (hoursNum >= maxHours) {
        hoursStr = String(maxHours);
    }
    else if (hoursNum < 0) {
        hoursStr = '00';
    }
    // Clamp and normalize minutes
    if (minutesStr !== undefined) {
        if (minutesNum > 59) {
            minutesStr = '59';
        }
        else if (minutesNum < 0) {
            minutesStr = '00';
        }
        else {
            minutesStr = minutesStr.padStart(2, '0');
        }
    }
    // Clamp and normalize seconds (if applicable)
    if (secondsStr !== undefined) {
        var secondsNum = +secondsStr || 0;
        if (secondsNum > 59) {
            secondsStr = '59';
        }
        else if (secondsNum < 0) {
            secondsStr = '00';
        }
        else {
            secondsStr = secondsStr.padStart(2, '0');
        }
    }
    // Build resulting time string
    var timeStr = hoursStr;
    if (minutesStr !== undefined) {
        timeStr += ":" + minutesStr;
        if (secondsStr === undefined && allowSeconds) {
            secondsStr = '00';
        }
    }
    if (secondsStr !== undefined) {
        timeStr += ":" + secondsStr;
    }
    if (meridiem) {
        timeStr += " " + meridiem;
    }
    return timeStr;
}
